export enum ChartType {
  Column = 'column',
  Line = 'line',
  Pie = 'pie',
}

export interface Chart {
  title: string;
  type: ChartType;
  data: ChartItem[];
  groupedData?: ChartItem[][];
  id: string;
  total?: number;
  modifiable: boolean;
}

export interface ChartItem {
  display?: string;
  label: string;
  value: number;
  isInprogress?: boolean;
  sortableValue?: string;
  keys?: string[];
}
